import { render, staticRenderFns } from "./FfgCarousel.vue?vue&type=template&id=0e5c6fa4&scoped=true&"
import script from "./FfgCarousel.vue?vue&type=script&lang=js&"
export * from "./FfgCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c6fa4",
  null
  
)

export default component.exports